import { AliyahType, ParashahType } from 'types/types'

import { formatParashahForStudent } from './Parashah'

export interface CreateAliyahParameters {
  id: number
  year: number | null
  parashah: ParashahType
  rank: number
  section: string
  variant: string
  comment: string
  username: string
}

enum AliyahRank {
  Rishon = 'רִאשׁוֹן',
  Sheni = 'שֵׁנִי',
  Shlishi = 'שְׁלִישִׁי',
  Revii = 'רְבִיעִי',
  Chamishi = 'חֲמִישִׁי',
  Shishi = 'שִׁישִׁי',
  Shevii = 'שְׁבִיעִי',
  Maftir = 'מַפְטִיר',
}
export const ALIYAH_RANK_MAP: Record<number, AliyahRank> = {
  1: AliyahRank.Rishon,
  2: AliyahRank.Sheni,
  3: AliyahRank.Shlishi,
  4: AliyahRank.Revii,
  5: AliyahRank.Chamishi,
  6: AliyahRank.Shishi,
  7: AliyahRank.Shevii,
  8: AliyahRank.Maftir,
}

export function rankName(rank: number): string {
  return ALIYAH_RANK_MAP[rank] ?? `Aliyah ${rank}`
}

export function formatRank(rank: number): string {
  return `${rank} - ${ALIYAH_RANK_MAP[rank]}`
}

export function formatAliyahSimple(aliyah: AliyahType): string {
  return `${formatRank(aliyah.rank)}`
}

export function formatAliyahForStudent(aliyah: AliyahType): string {
  return `${formatRank(aliyah.rank)} / ${formatParashahForStudent(aliyah.parashah)}`
}

export function formatAliyahForTeacher(aliyah: AliyahType): string {
  const parts = [aliyah.year != null ? String(aliyah.year) : null, aliyah.variant, aliyah.comment || null].filter(Boolean)
  return `${formatRank(aliyah.rank)} (${parts.join(' / ')})`
}

export function formatAliyahForTeacherWithSection(aliyah: AliyahType): string {
  return `${formatAliyahForTeacher(aliyah)}: ${aliyah.section}`
}

/** Null-safe year comparator: null sorts before any year. */
export function compareYear(a: { year?: number | null }, b: { year?: number | null }): number {
  return (a.year ?? 0) - (b.year ?? 0)
}

/** Sort aliyot by rank ascending. */
export function sortAliyotByRank<T extends { rank: number }>(aliyot: readonly T[]): T[] {
  return [...aliyot].sort((a, b) => a.rank - b.rank)
}
